module.exports = __webpack_public_path__ + "assets/loading.a7bbac631dfa8ab02a55275e7fab8bb9.gif";